module.exports = __webpack_public_path__ + "assets/staff.3fd50def.svg";